import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { useLocation } from 'react-router-dom'
import 'react-datepicker/dist/react-datepicker.css'
import BsCaretLeftFill from '@meronex/icons/bs/BsCaretLeftFill'
import CgRadioCheck from '@meronex/icons/cg/CgRadioCheck'
import BsChevronDown from '@meronex/icons/bs/BsChevronDown'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'

import {
  Title,
  CheckBoxWrapper,
  DateWrapper,
  TimeListWrapper,
  CheckedIcon,
  ButtonWrapper,
  OrderTimeWrapper,
  MonthYearLayer,
  DaysSwiper,
  Day,
  DayName,
  DayNumber,
  TimeItem,
  ClosedBusinessMsg,
  CheckIcon,
  Divider,
  AccordionSection,
  AccordionHeader,
  AccordionContent
} from './styles'

import {
  MomentOption,
  useLanguage,
  useUtils,
  useConfig,
  useOrder
} from '~components'

import {
  Button,
  WeekCalendarPicker,
  getTimes as getTimesUtils
} from '~ui'

import { CustomLayout } from './layouts/CustomLayout'

const MomentControlUI = (props) => {
  const {
    isAsap,
    datesList,
    hoursList,
    dateSelected,
    timeSelected,
    handleAsap,
    handleChangeDate,
    handleChangeTime,
    onClose,
    isAppoint,
    cateringPreorder,
    isCart,
    preorderLeadTime,
    business,
    getActualSchedule,
    preorderMaximumDays,
    preorderMinimumDays,
    isUseWeekPicker
  } = props

  const [{ configs }] = useConfig()
  const is12hours = configs?.general_hour_format?.value?.includes('hh:mm')
  const [{ parseTime }] = useUtils()
  const { pathname } = useLocation()
  const [, t] = useLanguage()
  const [orderState] = useOrder()
  const [isASP, setIsASP] = useState(!orderState?.options?.moment)
  const [timeList, setTimeList] = useState([])
  const [scheduleList, setScheduleList] = useState(null)
  const [isEnabled, setIsEnabled] = useState(true)
  const [nextTime, setNextTime] = useState(null)
  const [activeAccordions, setActiveAccordions] = useState(['dates'])

  const handleCheckBoxChange = (index) => {
    if (index) {
      !orderState.loading && handleAsap()
      setIsASP(true)
    } else setIsASP(false)
  }

  const validateSelectedDate = (curdate, schedule) => {
    const day = moment(curdate).format('d')
    setIsEnabled(schedule[day].enabled)
  }

  const getTimes = (curdate, schedule) => {
    validateSelectedDate(curdate, schedule)
    const dateParts = curdate?.split?.('-')
    const dateSeleted = new Date(dateParts[0], dateParts[1] - 1, dateParts[2])
    const times = getTimesUtils(dateSeleted, schedule, is12hours)
    return times
  }

  const setLocalMoment = () => {
    moment.updateLocale('custom', {
      months: [
        t('MONTH1', 'January'),
        t('MONTH2', 'February'),
        t('MONTH3', 'March'),
        t('MONTH4', 'April'),
        t('MONTH5', 'May'),
        t('MONTH6', 'June'),
        t('MONTH7', 'July'),
        t('MONTH8', 'August'),
        t('MONTH9', 'September'),
        t('MONTH10', 'October'),
        t('MONTH11', 'November'),
        t('MONTH12', 'December')
      ],
      monthsShort: [
        t('MONTHSHORT1', 'Jan'),
        t('MONTHSHORT2', 'Feb'),
        t('MONTHSHORT3', 'Mar'),
        t('MONTHSHORT4', 'Apr'),
        t('MONTHSHORT5', 'May'),
        t('MONTHSHORT6', 'Jun'),
        t('MONTHSHORT7', 'Jul'),
        t('MONTHSHORT8', 'Aug'),
        t('MONTHSHORT9', 'Sep'),
        t('MONTHSHORT10', 'Oct'),
        t('MONTHSHORT11', 'Nov'),
        t('MONTHSHORT12', 'Dec')
      ],
      weekdays: [
        t('DAY7', 'Sunday'),
        t('DAY1', 'Monday'),
        t('DAY2', 'Tuesday'),
        t('DAY3', 'Wednesday'),
        t('DAY4', 'Thursday'),
        t('DAY5', 'Friday'),
        t('DAY6', 'Saturday')
      ],
      weekdaysShort: [
        t('DAYSHORT7', 'Sun'),
        t('DAYSHORT1', 'Mon'),
        t('DAYSHORT2', 'Tue'),
        t('DAYSHORT3', 'Wed'),
        t('DAYSHORT4', 'Thu'),
        t('DAYSHORT5', 'Fri'),
        t('DAYSHORT6', 'Sat')
      ],
      weekdaysMin: [
        t('DAYMIN7', 'Su'),
        t('DAYMIN1', 'Mo'),
        t('DAYMIN2', 'Tu'),
        t('DAYMIN3', 'We'),
        t('DAYMIN4', 'Th'),
        t('DAYMIN5', 'Fr'),
        t('DAYMIN6', 'Sa')
      ],
      meridiem: function (hours) {
        return hours < 12 ? t('AM', 'AM') : t('PM', 'PM')
      }
    })
  }

  const formatTimeDisplay = (time) => {
    if (!time) return ''
    if (is12hours) {
      if (time.includes('PM') || time.includes('AM')) {
        const period = time.includes('PM') ? 'PM' : 'AM'
        const timeStr = time.replace(/PM|AM/g, '').trim()
        const [hours, minutes] = timeStr.split(':')
        return {
          hours,
          minutes,
          period
        }
      }
      const [timeStr, period] = time.split(' ')
      const [hours, minutes] = timeStr.split(':')
      return {
        hours,
        minutes,
        period
      }
    }

    const [hours, minutes] = time.split(':')
    return {
      hours,
      minutes,
      period: null
    }
  }

  const toggleAccordion = (section) => {
    setActiveAccordions(prev => {
      if (prev.includes(section)) {
        return prev.filter(item => item !== section)
      } else {
        return [...prev, section]
      }
    })
  }

  useEffect(() => {
    let _timeLists = []
    if (!scheduleList || cateringPreorder) {
      const schedule = business && Object.keys(business || {})?.length > 0 && getActualSchedule()
      if (!schedule && cateringPreorder && Object.keys(business)?.length > 0) {
        setIsEnabled(false)
        return
      }
      _timeLists = hoursList
        .filter(hour => (Object.keys(business || {})?.length === 0 || schedule?.lapses?.some(lapse =>
          moment(dateSelected + ` ${hour.startTime}`) >= moment(dateSelected + ` ${lapse.open.hour}:${lapse.open.minute}`).add(preorderLeadTime, 'minutes') && moment(dateSelected + ` ${hour.endTime}`) <= moment(dateSelected + ` ${lapse.close.hour}:${lapse.close.minute}`))) &&
          moment(dateSelected + ` ${hour.startTime}`) < moment(dateSelected + ` ${hour.endTime}`) &&
          (moment().add(preorderLeadTime, 'minutes') < moment(dateSelected + ` ${hour.startTime}`) || !cateringPreorder))
        .map(hour => {
          return {
            value: hour.startTime,
            text: is12hours
              ? (
                  hour.startTime.includes('12')
                    ? `${hour.startTime}PM`
                    : parseTime(moment(hour.startTime, 'HH:mm'), { outputFormat: 'hh:mma' })
                )
              : (
                  parseTime(moment(hour.startTime, 'HH:mm'), { outputFormat: 'HH:mm' })
                ),
            endText: is12hours
              ? (
                  hour.endTime.includes('12')
                    ? `${hour.endTime}PM`
                    : parseTime(moment(hour.endTime, 'HH:mm'), { outputFormat: 'hh:mma' })
                )
              : (
                  parseTime(moment(hour.endTime, 'HH:mm'), { outputFormat: 'HH:mm' })
                )
          }
        })
      setIsEnabled(true)
    } else {
      _timeLists = getTimes(dateSelected, scheduleList)
    }
    setTimeList(_timeLists)
  }, [dateSelected, hoursList, scheduleList, cateringPreorder, JSON.stringify(business)])

  useEffect(() => {
    handleCheckBoxChange(isAsap && ((preorderMinimumDays === 0 && preorderLeadTime === 0) || !cateringPreorder))
  }, [isAsap])

  useEffect(() => {
    if ((!pathname.includes('store') || isCart) && !props.business) {
      setScheduleList(null)
      return
    }

    const schedules = JSON.parse(window.localStorage.getItem('business_schedule'))
    setScheduleList(schedules)
  }, [pathname])

  useEffect(() => {
    setLocalMoment()
  }, [])

  useEffect(() => {
    if (preorderMinimumDays === 0 && preorderLeadTime === 0) return
    const isToday = dateSelected === moment().format('YYYY-MM-DD')
    if (isCart && isToday && !orderState?.loading && timeList?.length > 0) {
      setNextTime(timeList?.[0] ?? null)
    }
  }, [timeList?.length])

  useEffect(() => {
    if (nextTime?.value && timeList?.length > 0 && isCart && !orderState?.loading && !(preorderMinimumDays === 0 && preorderLeadTime === 0)) {
      const notime = timeList?.filter((_, i) => i !== 0)?.find?.(time => time?.value === timeSelected)
      if (!notime) {
        handleChangeTime(nextTime?.value)
      }
    }
  }, [nextTime?.value])

  return (
    <div id='moment_control'>
      {!isAppoint && (
        <>
          {!isCart && (
            <Title>{t('DELIVERY_TIME', 'Delivery time')}</Title>
          )}
          {((preorderMinimumDays === 0 && preorderLeadTime === 0) || !cateringPreorder) && (
            <CheckBoxWrapper
              highlight={isAsap && isASP}
              onClick={() => handleCheckBoxChange(true)}
              isLoading={orderState?.loading}
            >
              <span>{t('CHECKOUT_ASAP', 'ASAP')} ({moment(new Date()).format(`dddd, MMMM DD, YYYY ${configs?.general_hour_format?.value}`)} + {t('DELIVERY_TIME', 'delivery time')})</span>
              {isASP ? <CheckedIcon /> : <CgRadioCheck />}
            </CheckBoxWrapper>
          )}
          <CheckBoxWrapper
            highlight={!isASP}
            onClick={() => handleCheckBoxChange(null)}
          >
            <span>{t('SCHEDULE_FOR_LATER', 'Schedule for later')}</span>
            {isASP ? <CgRadioCheck /> : <CheckedIcon />}
          </CheckBoxWrapper>
        </>
      )}
      {
        (!isASP || isAppoint) && (
          !props.isCustomLayout
            ? (
              <>
                <Divider />
                <OrderTimeWrapper>
                  {!isAppoint && !isCart && <p>{t('ORDER_TIME', 'Order time')}</p>}
                  <MonthYearLayer>
                    <span>
                      {
                        datesList.slice((cateringPreorder && preorderMinimumDays) || 0, Number(cateringPreorder ? preorderMaximumDays : configs?.max_days_preorder?.value ?? 6, 10))?.length === 0
                          ? moment(dateSelected).format('Do MMMM, yyyy')
                          : moment(dateSelected).format('MMMM, yyyy')
                      }
                    </span>
                  </MonthYearLayer>
                  <AccordionSection>
                    <AccordionHeader
                      active={activeAccordions.includes('dates')}
                      onClick={() => toggleAccordion('dates')}
                    >
                      <span>{t('CHOOSE_DATE', 'Choose Date')}</span>
                      <BsChevronDown />
                    </AccordionHeader>
                    <AccordionContent active={activeAccordions.includes('dates')}>
                      {isUseWeekPicker
                        ? (
                            <DateWrapper>
                              <DaysSwiper left={<BsCaretLeftFill />}>
                                <Swiper
                                  spaceBetween={0}
                                  navigation
                                  modules={[Navigation]}
                                  breakpoints={{
                                    0: {
                                      slidesPerView: 4,
                                      spaceBetween: 0
                                    },
                                    400: {
                                      slidesPerView: 5,
                                      spaceBetween: 0
                                    },
                                    550: {
                                      slidesPerView: 6,
                                      spaceBetween: 0
                                    },
                                    769: {
                                      slidesPerView: configs?.max_days_preorder?.value < 7 ? configs?.max_days_preorder?.value : 7,
                                      spaceBetween: 0
                                    }
                                  }}
                                  freeMode
                                  watchSlidesProgress
                                  className='swiper-datelist'
                                  preventClicksPropagation={false}
                                >
                                  {
                                    datesList.slice((cateringPreorder && preorderMinimumDays) || 0, Number(cateringPreorder ? preorderMaximumDays : configs?.max_days_preorder?.value ?? 6, 10)).map(date => {
                                      const dateParts = date.split('-')
                                      const _date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2])
                                      const dayName = t('DAY' + (_date.getDay() >= 1 ? _date.getDay() : 7)).substring(0, 2)
                                      const dayNumber = (_date.getDate() < 10 ? '0' : '') + _date.getDate()
                                      return (
                                        <SwiperSlide key={dayNumber}>
                                          <Day selected={dateSelected === date} onClick={() => handleChangeDate(date)}>
                                            <DayName isAppoint={isAppoint}>{dayName}</DayName>
                                            <DayNumber isAppoint={isAppoint}>{dayNumber}</DayNumber>
                                          </Day>
                                        </SwiperSlide>
                                      )
                                    })
                                  }
                                </Swiper>
                              </DaysSwiper>
                            </DateWrapper>
                          )
                        : (
                            <WeekCalendarPicker
                              datesList={datesList}
                              dateSelected={dateSelected}
                              handleChangeDate={handleChangeDate}
                              configs={configs}
                              cateringPreorder={cateringPreorder}
                              preorderMinimumDays={preorderMinimumDays}
                              preorderMaximumDays={preorderMaximumDays}
                            />
                          )}
                    </AccordionContent>
                  </AccordionSection>

                  <AccordionSection>
                    <AccordionHeader
                      active={activeAccordions.includes('times')}
                      onClick={() => toggleAccordion('times')}
                    >
                      <span>{t('CHOOSE_TIME', 'Choose Time')}</span>
                      <BsChevronDown />
                    </AccordionHeader>
                    <AccordionContent active={activeAccordions.includes('times')}>
                      <TimeListWrapper>
                        {(isEnabled && timeList?.length > 0)
                          ? (
                          <>
                            {timeList.map((time, i) => {
                              const formattedTime = formatTimeDisplay(time.text)
                              return (
                                <TimeItem
                                  key={i}
                                  active={timeSelected === time.value}
                                  onClick={() => handleChangeTime(time.value)}
                                  isAppoint={isAppoint}
                                  cateringPreorder={cateringPreorder}
                                  is12hours={is12hours}
                                >
                                  <span>
                                    {cateringPreorder && (
                                      <CheckIcon>
                                        {timeSelected === time.value ? <CheckedIcon cateringPreorder={cateringPreorder} /> : <CgRadioCheck />}
                                      </CheckIcon>
                                    )}
                                    <div className='time-container'>
                                      <p id='hours'>{formattedTime.hours}</p>
                                      <p id='separator'>:</p>
                                      <p id='minutes'>{formattedTime.minutes}</p>
                                    </div>
                                    {formattedTime.period && <p id='period'>{formattedTime.period}</p>}
                                  </span>
                                </TimeItem>
                              )
                            })}
                          </>
                            )
                          : (
                          <ClosedBusinessMsg>
                            {!business
                              ? t('ERROR_SHEDULE_UNAVAILABLE', 'There are no schedules for this date')
                              : t('ERROR_ADD_PRODUCT_BUSINESS_CLOSED', 'The business is closed at the moment')}
                          </ClosedBusinessMsg>
                            )}
                      </TimeListWrapper>
                    </AccordionContent>
                  </AccordionSection>
                </OrderTimeWrapper>
              </>
              )
            : (
            <CustomLayout
              handleChangeDate={handleChangeDate}
              datesList={datesList}
              hoursList={hoursList}
              isEnabled={isEnabled}
              timeList={timeList}
              timeSelected={timeSelected}
              handleChangeTime={handleChangeTime}
            />
              )
        )
      }
      {!isAppoint && !isCart && (
        <ButtonWrapper>
          <Button
            color='primary'
            onClick={() => onClose()}
            disabled={!isASP ? !timeSelected : false}
          >
            <span>{t('SAVE', 'Save')}</span>
          </Button>
        </ButtonWrapper>
      )}
    </div>
  )
}

export const MomentControl = (props) => {
  const momentProps = {
    ...props,
    UIComponent: MomentControlUI
  }
  return <MomentOption {...momentProps} />
}
